module.exports = __webpack_public_path__ + "img/landscape-6.f8384e1e.jpg";